// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"cb03c708","216":"69110cfc","553":"0304d5c8","828":"9cd97c1c","852":"d9138994","996":"4df9027c"}[chunkId] + ".chunk.js";
};